module.exports = __webpack_public_path__ + "static/images/hengfu_d71254a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/posbannerblack/hengfu.png
// module id = 237
// module chunks = 1